import { render, staticRenderFns } from "./MainPageLayout.vue?vue&type=template&id=1258ae77&scoped=true&"
import script from "./MainPageLayout.vue?vue&type=script&lang=js&"
export * from "./MainPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./MainPageLayout.vue?vue&type=style&index=0&id=1258ae77&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1258ae77",
  null
  
)

export default component.exports